import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BehfaRole_Interface, Empty_BehfaRole_Interface } from 'src/app/Interface/BehfaRole_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BehfaRoleService } from 'src/app/Service/BehfaRole/BehfaRole.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-BehfaRoleListAdmin',
  templateUrl: './BehfaRoleListAdmin.component.html',
  styleUrls: ['./BehfaRoleListAdmin.component.scss']
})
export class BehfaRoleListAdminComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private BehfaRole_Service:BehfaRoleService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_BehfaRole:Array<BehfaRole_Interface>=[]
  Data_Seleted_Delete:BehfaRole_Interface=Empty_BehfaRole_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1105).subscribe(
      data=>{
        this.ReadData_BehfaRole()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_BehfaRole(){
    this.Procssing=true
    this.BehfaRole_Service.GetRecord().subscribe(
      data=>{
        this.DataList_BehfaRole=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:BehfaRole_Interface){
    item.deletingProccess=true
    this.modalRef_Delete.hide()
    this.BehfaRole_Service.DeleteBehfaRole(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_BehfaRole()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Priority(item:BehfaRole_Interface){
    item.deletingProccess=true
    this.BehfaRole_Service.PriorityBehfaRole(item.id).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          
        this.ReadData_BehfaRole()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
